// frontend/src/api/valuationEmail.ts
//
// ADD_VAL-REPORT-EMAIL-1 - "Email document". The recipient is chosen by the server (the
// email on file). VAL-EMAIL-ENTRY-1: only when none is on file, or when the sender chooses to
// change it, does this send an address - which the server validates, saves and audits.
import { apiClient } from '@/api/client'

export interface DocumentEmailInfo {
  can_email: boolean
  /** No client email on file: show the "Client email" box. */
  needs_email?: boolean
  /** A document for the live version is archived. */
  archived: boolean
  /** e.g. j*******@acme.com - null when no client email is on file. */
  to_masked: string | null
  /** Why the button is disabled, in the server's words. */
  reason: string | null
  /** ISO date of the last successful send of the live version. */
  emailed_on: string | null
}

const url = (id: string) => `/v1/valuation/engagements/${id}/document-email`

export async function fetchDocumentEmail(engagementId: string): Promise<DocumentEmailInfo> {
  const { data } = await apiClient.get<DocumentEmailInfo>(url(engagementId))
  return data
}

export async function sendDocumentEmail(
  engagementId: string,
  clientEmail?: string,
): Promise<{ message: string; to_masked: string }> {
  const { data } = await apiClient.post<{ message: string; to_masked: string }>(
    url(engagementId),
    clientEmail ? { client_email: clientEmail } : undefined,
  )
  return data
}
